import { contentFetch } from "../contentClient.js";

// ============= Value Types API (v2, read-only) =============

const BASE = "/api/v2/value-types";

export async function getValueTypes(init) {
    return contentFetch(BASE, init);
}

export async function getValueTypeById(valueTypeId, init) {
    return contentFetch(`${BASE}/${valueTypeId}`, init);
}
